import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
const scrollToPricing = () => {
  const pricingSection = document.getElementById('pricing');
  if (pricingSection) {
    pricingSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-aged-green text-white pt-16 pb-10" data-id="element-88">
      {/* Subtle vignette effect */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-black/20 pointer-events-none" data-id="element-89"></div>

      {/* Decorative Background Elements with golden sparkles */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-90">
        {/* Golden shimmer effects */}
        <motion.div animate={{
        y: [0, -30, 0],
        rotate: [0, 10, 0],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-[5%] left-[5%] w-72 h-72 bg-yellow-400 rounded-full mix-blend-screen opacity-20 blur-3xl" data-id="element-91" />
        <motion.div animate={{
        y: [0, 40, 0],
        rotate: [0, -10, 0],
        opacity: [0.15, 0.3, 0.15]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-[10%] right-[5%] w-96 h-96 bg-yellow-500 rounded-full mix-blend-screen opacity-15 blur-3xl" data-id="element-92" />

        {/* Additional golden sparkle spots */}
        <motion.div animate={{
        opacity: [0.3, 0.6, 0.3],
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} className="absolute top-[40%] right-[20%] w-32 h-32 bg-yellow-300 rounded-full mix-blend-screen opacity-25 blur-2xl" data-id="element-93" />
        <motion.div animate={{
        opacity: [0.2, 0.5, 0.2],
        scale: [1, 1.3, 1]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} className="absolute bottom-[30%] left-[15%] w-40 h-40 bg-yellow-400 rounded-full mix-blend-screen opacity-20 blur-2xl" data-id="element-94" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-95">
        <div className="max-w-5xl mx-auto text-center" data-id="element-96">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-8" data-id="element-97">
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tight leading-none flex items-center justify-center gap-4 mb-6 text-stroke-black-lg" style={{
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5)) drop-shadow(0 8px 16px rgba(0,0,0,0.4)) drop-shadow(0 12px 24px rgba(0,0,0,0.3))'
          }} data-id="element-98">
              <Sparkles size={60} className="hidden md:inline-block text-yellow-300" data-id="element-99" />
              <span className="italic text-yellow-400" data-id="element-100">El Milagro</span>
              <Sparkles size={60} className="hidden md:inline-block text-yellow-300" data-id="element-101" />
            </h1>
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-black text-white tracking-tight leading-none italic text-stroke-black-lg" style={{
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5)) drop-shadow(0 8px 16px rgba(0,0,0,0.4)) drop-shadow(0 12px 24px rgba(0,0,0,0.3))'
          }} data-id="element-102">
              del Sobre
            </h1>

            {/* Gold divider line */}
            <div className="flex justify-center mt-8 mb-8" data-id="element-103">
              <div className="gold-divider" data-id="element-104"></div>
            </div>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-8 tracking-tight" data-id="element-105">
            Cómo dejar de sobrevivir la quincena y empezar a{' '}
            <span className="text-yellow relative inline-block" data-id="element-106">
              sentir control
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-yellow" viewBox="0 0 200 9" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-107">
                <path d="M2.00025 6.99997C25.7509 2.83332 72.0841 -3.66667 198.001 2.99997" stroke="currentColor" strokeWidth="3" data-id="element-108" />
              </svg>
            </span>{' '}
            con el dinero que ya tienes
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-2xl max-w-2xl mx-auto font-medium leading-relaxed mb-10" data-id="element-109">
            <span className="text-[#f5f0e8]" data-id="element-110">
              Sin ganar más. Sin dejar de vivir. Solo con un sistema{' '}
            </span>
            <span className="text-yellow-400 italic font-serif" data-id="element-111">
              que sí funciona para tu realidad.
            </span>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-112">
            <Button variant="gold" size="lg" className="font-black text-xl" onClick={scrollToPricing} data-id="element-113">
              Descubre Cómo
            </Button>
          </motion.div>

          {/* Product Image */}
        </div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-114"></div>
    </section>;
}